<div class="access-denied-container">
  <div class="content">
    <div class="image-no-access-results">
    </div>
    <div class="access-denied-header">
      {{ 'Access.NoAccess' | translate }}
    </div>
    <div class="access-denied-message">
      {{ 'Access.NoAccessMessage' | translate }}
    </div>
    <div class="button-container">
      <wdpr-button theme="inline-primary" (click)="redirectToLogin()">{{ 'Common.TryAgain' | translate }}</wdpr-button>
    </div>
  </div>
</div>